module.exports = __webpack_public_path__ + "img/activity_christmas1.861a6e8c.jpg";